import axios from './axios'
import config from '../config'

export default {
    listDatasourceConfigs(params) {
        return axios({
            url: config.backendUrl + '/common/datasource-configs',
            method: 'GET',
            params
        })
    },
    batchGetDatasourceConfigsByIds(ids){
        return axios({
            url: config.backendUrl + '/common/datasource-configs/batch-by-ids',
            method: 'GET',
            params: {ids}
        })
    },
    addDatasourceConfig(data) {
        return axios({
            url: config.backendUrl + '/op/admin/datasource-configs',
            method: 'POST',
            data
        })
    },
    updateDatasourceConfig(data) {
        return axios({
            url: config.backendUrl + '/op/admin/datasource-configs',
            method: 'PUT',
            data
        })
    },
    getDatasourceConfig(id) {
        return axios({
            url: config.backendUrl + '/common/datasource-configs/' + id,
            method: 'GET'
        })
    },
    deleteDatasourceConfig(id) {
        return axios({
            url: config.backendUrl + '/op/admin/datasource-configs/' + id,
            method: 'DELETE'
        })
    },
    getTypes(){
        return [
            {
                label: '资讯',
                value: 'news'
            },
            {
                label: '论坛',
                value: 'bbs'
            },
            {
                label: '博客',
                value: 'blog'
            },
            {
                label: '微博',
                value: 'weibo'
            }
        ]
    }
}
